import { render, staticRenderFns } from "./pontos.vue?vue&type=template&id=7780ed7a"
import script from "./pontos.ts?vue&type=script&lang=js&external"
export * from "./pontos.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7780ed7a')) {
      api.createRecord('7780ed7a', component.options)
    } else {
      api.reload('7780ed7a', component.options)
    }
    module.hot.accept("./pontos.vue?vue&type=template&id=7780ed7a", function () {
      api.rerender('7780ed7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/cliente/pontos.vue"
export default component.exports